import { ShowsProvider } from "@/context/shows";
import ShowsSlider from "@/Components/User/Shows/ShowsSlider";
import User from "@/Layouts/User";
import ShowsFilter from "@/Components/User/Shows/ShowsFilter";
import ShowsListing from "@/Components/User/Shows/ShowsListing";
import Head from "next/head";
import MetaTags from "@/Components/SEO/MetaTags";
import { Schema } from '@/Components/SEO/Schema';
import withBaseUrl from "@/Utils/const";

export default function ShowsPage() {

    const getBreadcrumbs = () => {
        return [
            {
                name: 'Home',
                url: withBaseUrl('/')
            },
            {
                name: 'Shows',
                url: withBaseUrl('/shows')
            }
        ];
    };

    return (
        <ShowsProvider >
            <MetaTags
                title="Qoncert Shows - Browse Upcoming Concerts"
                description="Browse and discover upcoming concerts and live music events. Find tickets for your favorite artists and discover new talent with Qoncert."
                keywords="concerts, live music, tickets, events, music festivals, upcoming shows, live performances"
                canonicalUrl="/shows"
            />
            <Head>
                <title>Shows | Qoncert</title>
                <Schema breadcrumbs={getBreadcrumbs()} />
            </Head>
            <User>
                <ShowsSlider />
                <ShowsFilter />
                <ShowsListing />
            </User>
        </ShowsProvider>
    );
}

